import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  deleteSubCategory: [],
  loading: false,
  error: null,
};

const deleteSubCategorySlice = createSlice({
  name: "deleteSubCategory",
  initialState,
  reducers: {
    fetchDeleteSubCategorySuccess: (state, action) => {
      state.loading = false;
      state.deleteSubCategory = action.payload;
    },

    fetchDeleteSubCategoryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchDeleteSubCategorySuccess,
  fetchDeleteSubCategoryFailure,
} = deleteSubCategorySlice.actions;

export default deleteSubCategorySlice.reducer;